import { User } from '../microservices';
import { getBaseUrl } from '../../maps/apiEnvironmentMap';

export class MeRequestGET {
  readonly method: string = 'auth/me';
  public buildURL() {
    let baseURL = getBaseUrl('security');
    return `${baseURL}/${this.method}`;
  }
  public generateConfig(token: string) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  }
}
export type MeResponseGET = {
  status: string;
  message: string;
  data: {
    user: User;
    message: string;
    errors: any;
  };
};
